import { render, staticRenderFns } from "./tutorDetail.vue?vue&type=template&id=cce15d64&scoped=true&"
import script from "./tutorDetail.vue?vue&type=script&lang=js&"
export * from "./tutorDetail.vue?vue&type=script&lang=js&"
import style0 from "./tutorDetail.vue?vue&type=style&index=0&id=cce15d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce15d64",
  null
  
)

export default component.exports